import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/default/index'
import brandStyle from '@/views/default/brandStyle'
import detail from '@/views/carfestival/detail'
import perfect from '@/views/carfestival/perfect'
import suc from '@/views/carfestival/suc'
import over from '@/views/carfestival/over'
import publicpage from '@/views/carfestival/publicpage'

import detailBrand from '@/views/signupPhp/detailBrand'
import detailCarstyle from '@/views/signupPhp/detailCarstyle'
import infomation from '@/views/signupPhp/infomation'
import success from '@/views/signupPhp/success'
import pricePage from '@/views/signupPhp/pricePage'


/***************************分销头条报名页面******************************/
import toutiaoApplypage from '@/views/toutiao/applypage'
import toutiaoApplypageSuc from '@/views/toutiao/success'
import toutiaoQuotationpage from '@/views/toutiaoQuotation/quotationpage'
import toutiaoQuotationperfect from '@/views/toutiaoQuotation/quotationperfect'


/**********************比较车型信息***************************/
import comparison from '@/views/comparison/index'
import comparisonList from '@/views/comparison/comparison'
import parameter from '@/views/comparison/parameter'
import demoindex from '@/views/demo/index'

/***************************五洲车博会报名页面******************************/
import carExpopage from '@/views/carExpo/carExpopage'
import carExpoperfect from '@/views/carExpo/carExpoperfect'
import carExpoSuccess from '@/views/carExpo/carExpoSuccess'
import carExpoSignup from '@/views/carExpo/carExpoSignup'

 /***************************私人订制*************************/
import cusindex from '@/views/customize/index'

/************团购****************/
import groupbuy from '@/views/groupbuy/index'
import grouplistpage from '@/views/groupbuy/grouplist'

  /******************************违章***************************************/ 
import violationIndex from '@/views/violation/index'
import violationAddCar from '@/views/violation/addCar'
import violationResult from '@/views/violation/checkResult'

/********************三线城市*****************/
import threeindex from '@/views/threecity/threecityindex'

  /******************************计算器***************************************/ 
import calculatorIndex from '@/views/calculator/index'
import calcuShare from '@/views/calculator/calcuShare'
//import calculatorinformationPerfect from '@/views/calculator/informationPerfect'
//import fullSectionPage from '@/views/calculator/fullSectionPage'
//import loanPage from '@/views/calculator/loanPage'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [{
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/:cityPy',
      name: 'index',
      component: index
    },
    /*注意  必须放在detail页面的前面*/
    //https://m.tuanche.com/hmtcj/applySupplement?showAddress=0&applyId=13760759&t=1530263398000&sk=e3c4632f08447abd862d5963b1c6632e&buyway=0&instalments=0&otherbrand=0&newbyv=0&periodsId=1557
    {
      path: '/hmtcj/applySupplement',
      name: 'perfect',
      component: perfect
    },
    {	
      path: '/hmtcj/publicpage',
      name: 'publicpage',
      component: publicpage
    },
    /*注意  必须在detail页面前面*/
    //https://m.tuanche.com/hmtcj/suc?applyId=13760759&periodsId=1557&t=1530269917000
    {
      path: '/hmtcj/suc',
      name: 'suc',
      component: suc
    },
    {
      path: '/hmtcj/end',
      name: 'end',
      component: over
    },
    {
      path: '/hmtcj/:cityPy',
      name: 'detail',
      component: detail
    },
    {
      path: '/:cityPy/b:brandId/tuan',
      name: 'detailBrand',
      component: detailBrand
    },
    {
      path: '/:cityPy/c:carStyleId/tuan', //path: '/:cityPy/c:carStyleId/:styleName/tuan',
      name: 'detailCarstyle',
      component: detailCarstyle
    },
    {
      path: '/GroupBuy/addApply',
      name: 'infomation',
      component: infomation
    },
    {
      path: '/GroupBuy/addInfo',
      name: 'success',
      component: success
    },
    {
      path: '/mapply/GroupBuy/pricePage',
      name: 'pricePage',
      component: pricePage
    },
    {
      path: '/:cityPy/plan',
      name: 'brandStyle',
      component: brandStyle	
    },
    
   	/***************************分销头条报名页面*************************/
   	{
      path: '/mapply/toutiaoApplypage',
      name: 'toutiaoApplypage',
      component: toutiaoApplypage
    },
    {
      path: '/mapply/toutiaoApplypage/suc',
      name: 'toutiaoApplypageSuc',
      component: toutiaoApplypageSuc
    },
    {
    	path: '/mapply/toutiaoQuotationpage',
      name: 'toutiaoQuotationpage',
      component: toutiaoQuotationpage
    },
    {
      path: '/mapply/toutiaoQuotation/perfect',
      name: 'toutiaoQuotationperfect',
      component: toutiaoQuotationperfect
    },

    /****************************对比车型*************************************/
    {
      path: '/mapply/comparison',
      name: 'comparison',
      component: comparison
    },
    {
      path: '/mapply/comparisonlist',
      name: 'comparisonList',
      component: comparisonList
    },
    {
      path: '/mapply/comparisonparameter',
      name: 'parameter',
      component: parameter
    },
    

    /***************************五洲车博会报名页面*************************/
	{
    	path: '/mapply/carExpo/carExpoperfect/suc',
      name: 'carExpoperfect',
      component: carExpoperfect
   	},
   	{
    	path: '/mapply/carExpo/carExpoSuccess',
      name: 'carExpoSuccess',
      component: carExpoSuccess
   	},
   	{
    	path: '/mapply/carExpo/carExpoSignup',
      name: 'carExpoSignup',
      component: carExpoSignup
    },
    {
    	path: '/mapply/carExpo',
      name: 'carExpopage',
      component: carExpopage
    },
	/***************************私人订制*************************/
    {
      path: '/mapply/customize/index',
      name: 'cusindex',
      component: cusindex	
    },
     /************团购****************/
   {
   	  path: '/mapply/groupbuy/index',
      name: 'groupbuy',
      component: groupbuy	
   },
    {
   	  path: '/mapply/groupbuy/grouplist',
      name: 'grouplistpage',
      component: grouplistpage	
    },
     /******************************违章***************************************/ 
    {
      path: '/mapply/violationaddcar',
      name: 'violationAddCar',
      component: violationAddCar
    },
    {
      path: '/mapply/violationindex',
      name: 'violationIndex',
      component: violationIndex
    },
    {
      path: '/mapply/violationresult',
      name: 'violationResult',
      component: violationResult
    },
     {
      path: '/mapply/demo/index',
      name: 'demoindex',
      component: demoindex
    },	/***************************三线城市*************************/
   	{
   	  path: '/mapply/threecity/threecityindex',
      name: 'threeindex',
      component: threeindex	
   	},

      /******************************计算器***************************************/ 
    {
      path: '/mapply/calculatorIndex',
      name: 'calculatorIndex',
      component: calculatorIndex
    }, 
    {
      path: '/mapply/calcuShare',
      name: 'calcuShare',
      component: calcuShare
    },
//  {
//    path: '/mapply/loanPage',
//    name: 'loanPage',
//    component: loanPage
//  },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js